import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=d71ef7b0&scoped=true&"
import script from "./MainButton.vue?vue&type=script&lang=js&"
export * from "./MainButton.vue?vue&type=script&lang=js&"
import style0 from "./MainButton.vue?vue&type=style&index=0&id=d71ef7b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71ef7b0",
  null
  
)

export default component.exports